exports = module.exports = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n.sub-title[data-v-40c71d5e] {\n    color: #808891;\n}\n", ""]);

